<template>
    <div class="container">
        <div class="d-flex m-3 mt-4">
            <ion-icon name="folder-outline"></ion-icon>
            <h5 class="font-weight-bold text-dark mx-2"> صور ذات صلة </h5>
        </div>
        
        <div v-if="loader && itemsData.length !=0">
            <VueJustifiedLayout :items="itemsData" :options="{
  containerPadding: 10,
  forceAspectRatio: 0,
  fullWidthBreakoutRowCadence:0,
  showWidows: false,
  targetRowHeight:200,
  boxSpacing:3

}">
                <template slot-scope="{ item, index }" >
                    <router-link data-dismiss="modal" aria-label="Close" :to="{
            name: 'details',
            params: { id: item.id },
            query: {
              image: item.image,
              height: item.height,
              width: item.width,
              pres: (item.height / item.width) * 100,
            },
          }" class="cursor-pointer close">
                        <img :src="'https://pic.imamhussain.org/photos/preview/' + item.image" width="100%"
                             class="animate__animated animate__fadeIn" :style="`animation-delay:.${index}s`"
                             :alt="item.image" @click="scrollToTop"/>
                    </router-link>
                </template>
            </VueJustifiedLayout>
            <div class="row pb-5 justify-content-center animate__animated animate__fadeInUp my-3">
                <vs-button class="mb-5" @click="loadMore" v-if="items.next_page_url !=null" color="rgb(211, 186, 127)"
                           flat gradient
                           :loading="loading" size="large">
                    تحميل المزيد
                </vs-button>
            </div>
        </div>


    </div>
</template>
<script>


export default {

    props: ['category_id'],
    data() {
        return {
            category: [],
            cat_id: 0,
            page: 1,
            user: 0,
            sort: 'add_desc',
            limit: 20,
            featured: false,
            loader: false,
            loading: false,
            loading_sub: 0,
            items: [],
            itemsData: [],
            timer: null
        }
    },
    created() {

        if (this.category_id !== null) {

            this.fetchPhotos(this.category_id);

        }
    },

    watch: {

        category_id: function (val) {

            this.fetchPhotos(val);
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        fetchPhotos(id) {
            this.loader = false;
            this.items = [];
            this.loading = true;


            fetch(
                `https://pic.imamhussain.org/index.php/api/v2/photos?page=${this.page}&category=${id}&sort=${this.sort}&limit=${this.limit}&featured=${this.featured ? 1 : 0}`
            )
                .then(res => res.json()).then(res => {


                this.itemsData = res.data;
                this.items = res;

                this.loader = true;
                this.loading = false;
                this.loading_sub = 0;
            });
        },
        loadMore() {
            this.page++;
            this.loader = true;
            this.loading = true;
            fetch(
                `https://pic.imamhussain.org/index.php/api/v2/photos?page=${this.page}&category=${this.category_id}&sort=${this.sort}&limit=${this.limit}&featured=${this.featured ? 1 : 0}`
            )
                .then(res => res.json()).then(res => {


                for (let index = 0; index < res.data.length; index++) {
                    const element = res.data[index];
                    this.itemsData.push(element);
                }
                this.items = res;

                this.loader = true;
                this.loading = false;
                this.loading_sub = 0;
            });
        },
    },
}
</script>

<style scoped>

</style>